import React from "react"
import CustomImage from "@/main/customImage"
import { Col } from "react-bootstrap"

import ImageGallery from "react-image-gallery"

function Floorplans({ property }) {
    const renderImage = (item) => {
        return (
            <div className="mx-auto property-carousel-main  image-gallery-image">
                <CustomImage
                    src={item.original}
                    alt={item.originalAlt}
                    layout="fill"
                    objectFit="cover"
                    objectPosition="center"
                    sizes="100vw"
                    allowFullScreen
                />
            </div>
        )
    }

    const renderThumb = (item) => {
        return (
            <div className="property-carousel-thumb">
                <CustomImage
                    src={item.thumbnail}
                    alt={item.thumbAlt}
                    layout="fill"
                    objectFit="cover"
                    objectPosition="center"
                    sizes="10vw"
                />
            </div>
        )
    }
    const floorplans = property.floorplans.map((floorplan, index) => ({
        original: floorplan.imgix_url,
        thumbnail: floorplan.imgix_url,
        originalAlt: `Property ${property.property_ref} floorplan ${index}`,
        thumbAlt: `Property ${property.property_ref} floorplan thumbnail ${index}`,
        renderItem: renderImage,
        renderThumbInner: renderThumb,
        // description: floorplan.floorplan_text,
    }))

    return (
        <Col xs={12} className="px-0">
            <ImageGallery
                items={floorplans}
                autoplay={false}
                showIndex={true}
                showPlayButton={false}
                lazyload={true}
            />
        </Col>
    )
}

export default Floorplans
